var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bv-example-row"},[_c('list-table',{attrs:{"url":_vm.url,"title":"لیست تراکنش های لینک پرداخت هدفدار","fields":_vm.fields,"params":_vm.params,"excelroute":'excelroute',"back":true,"returnUrl":"/goal-link-list"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }